import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.search.js";
import { defineComponent as _defineComponent } from 'vue';
import settingsSvg from '~/assets/icons/settings.svg';
import { getActivityChipStyle, getActivityChipText } from '~/functions/csrd';
import { EnumIroType, useListStakeholdersQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'Stakeholder',
  setup: function setup(__props, _ref) {
    var expose = _ref.expose;
    var route = useRoute();
    var attrs = useAttrs();
    var headers = computed(function () {
      return [{
        value: 'id',
        sortable: true
      }, {
        value: 'name'
      }, {
        value: 'activityLinks'
      }, {
        value: 'positiveImpacts'
      }, {
        value: 'negativeImpacts'
      }, {
        value: 'risks'
      }, {
        value: 'opportunities'
      }, {
        value: 'actions'
      }].filter(function (o) {
        var _attrs$headers;
        return attrs === null || attrs === void 0 ? void 0 : (_attrs$headers = attrs.headers) === null || _attrs$headers === void 0 ? void 0 : _attrs$headers.includes(o.value);
      }).map(function (col) {
        return _objectSpread(_objectSpread({}, col), {}, {
          sortable: col.sortable || false
        });
      }) || [];
    });
    var _useNuxtApp = useNuxtApp(),
      $i18n = _useNuxtApp.$i18n;
    var locale = computed(function () {
      return $i18n.locale;
    });
    var options = ref({
      page: 1,
      itemsPerPage: 10,
      sortDesc: [true]
    });
    var search = ref('');
    var variables = computed(function () {
      var impactMaterial = ref();
      var financialMaterial = ref();
      if (route.query.materialStatus === 'both') {
        impactMaterial.value = true;
        financialMaterial.value = true;
      } else if (route.query.materialStatus === 'notMaterial') {
        impactMaterial.value = false;
        financialMaterial.value = false;
      } else if (route.query.materialStatus === 'impact') {
        impactMaterial.value = true;
      } else if (route.query.materialStatus === 'financial') {
        financialMaterial.value = true;
      }
      return {
        filters: {
          search: route.query.search || '',
          impactMaterial: impactMaterial.value,
          financialMaterial: financialMaterial.value
        },
        offset: options.value.itemsPerPage * (options.value.page - 1),
        limit: options.value.itemsPerPage
      };
    });
    var _useListStakeholdersQ = useListStakeholdersQuery(variables),
      result = _useListStakeholdersQ.result,
      refetch = _useListStakeholdersQ.refetch,
      loading = _useListStakeholdersQ.loading;
    expose({
      refetch: refetch
    });
    var items = computed(function () {
      var _result$value;
      return (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.listStakeholders;
    });
    var itemCount = computed(function () {
      var _result$value2;
      return (result === null || result === void 0 ? void 0 : (_result$value2 = result.value) === null || _result$value2 === void 0 ? void 0 : _result$value2.countStakeholders) || 0;
    });
    return {
      __sfc: true,
      route: route,
      attrs: attrs,
      headers: headers,
      $i18n: $i18n,
      locale: locale,
      options: options,
      search: search,
      variables: variables,
      result: result,
      refetch: refetch,
      loading: loading,
      items: items,
      itemCount: itemCount,
      settingsSvg: settingsSvg,
      getActivityChipStyle: getActivityChipStyle,
      getActivityChipText: getActivityChipText,
      EnumIroType: EnumIroType
    };
  }
});